export default __webpack_public_path__ + "static/media/furniture4.b2cee41c.jpeg";